<template>
    <main class="white-card-home">
        <header class="home-header">
            <strong>蓝猫儿童手表卡</strong>
            <button type="button" aria-label="联系客服" title="联系客服" @click="contactService">?</button>
        </header>

        <section class="home-content">
            <div class="home-hero">
                <span class="hero-burst" aria-hidden="true"></span>
                <div class="hero-cloud">
                    <h1>儿童电话手表</h1>
                    <h2>专用电话卡</h2>
                    <div class="hero-subtitle">
                        <span>亲情速联</span><i></i><span>信号满格</span><i></i><span>守护常在</span>
                    </div>
                </div>
                <div class="benefit-tags" aria-label="产品能力">
                    <span>📍 精准定位</span>
                    <span>📞 高清通话</span>
                    <span>🛡️ 防骚扰</span>
                    <span>🔒 家长管控</span>
                    <span>💰 资费透明</span>
                </div>
            </div>

            <section class="selling-points" aria-labelledby="sellingTitle">
                <h2 id="sellingTitle">为什么选蓝猫儿童手表卡</h2>
                <div class="selling-grid">
                    <div class="selling-item">
                        <span class="selling-icon">🎂</span>
                        <div><strong>生日号定制</strong><small>用孩子生日做尾号，专属又好记</small></div>
                    </div>
                    <div class="selling-item">
                        <span class="selling-icon">✨</span>
                        <div><strong>靓号自选</strong><small>后四位/中间四位随心挑，好号不贵</small></div>
                    </div>
                    <div class="selling-item">
                        <span class="selling-icon">💳</span>
                        <div><strong>人生首卡</strong><small>孩子第一张专属卡，蓝猫伴行</small></div>
                    </div>
                    <div class="selling-item">
                        <span class="selling-icon">🛡</span>
                        <div><strong>安全守护</strong><small>家长随时查状态、余额、消费</small></div>
                    </div>
                </div>
            </section>

            <div class="entry-list" aria-label="自助服务入口">
                <button class="entry-item" type="button" @click="startActivation">
                    <span class="entry-icon" aria-hidden="true">✨</span>
                    <span class="entry-copy">
                        <strong>激活新卡</strong>
                        <small>选号 · 装卡 · 套餐 · 实名，全程自助开户</small>
                    </span>
                    <van-icon class="entry-arrow" name="arrow" />
                </button>

                <button class="entry-item" type="button" @click="openRoute('/WhiteCardQuery')">
                    <span class="entry-icon" aria-hidden="true">🔍</span>
                    <span class="entry-copy">
                        <strong>号码查询</strong>
                        <small>查询号码状态、余额，并可在线充值</small>
                    </span>
                    <van-icon class="entry-arrow" name="arrow" />
                </button>

            </div>

            <p class="home-foot">已为 12 万+ 家庭开通 · 客服时间 8:00-21:00</p>
        </section>

        <button class="service-fab" type="button" aria-label="联系客服" title="联系客服" @click="contactService">
            <span class="service-pulse"></span>
            <img src="@/assets/images/whiteCard/logo.png" alt="" />
            <span>客服</span>
        </button>
        <WhiteCardCustomerService v-model="showCustomerService" />
    </main>
</template>

<script>
import { getWhiteCardRoute } from "./whiteCardRoute"
import WhiteCardCustomerService from "./WhiteCardCustomerService.vue"

const DRAFT_KEY = "whiteCardFlowDraftV1"
const REAL_NAME_PENDING_KEY = "whiteCardRealNamePending"

export default {
    name: "WhiteCardHome",
    components: {
        WhiteCardCustomerService,
    },
    data() {
        return {
            showCustomerService: false,
        }
    },
    methods: {
        startActivation() {
            localStorage.removeItem(DRAFT_KEY)
            localStorage.removeItem(REAL_NAME_PENDING_KEY)
            this.openRoute("/WhiteCardOpen")
        },
        openRoute(path) {
            this.$router.push(getWhiteCardRoute(path, this.$route))
        },
        contactService() {
            this.showCustomerService = true
        },
    },
}
</script>

<style scoped lang="scss">
.white-card-home,
.white-card-home * {
    box-sizing: border-box;
}

.white-card-home {
    --primary: #f4511e;
    --primary-2: #ff7043;
    --primary-soft: #fff0ec;
    --primary-ink: #c62828;
    --gold: #ff7043;
    --ink: #2a2336;
    --muted: #6e6678;
    --faint: #a89fae;
    width: 100%;
    max-width: 480px;
    min-height: 100vh;
    min-height: 100dvh;
    margin: 0 auto;
    color: var(--ink);
    background: #fff;
    position: relative;
    overflow-x: hidden;
    font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.home-header {
    height: 58px;
    padding: max(8px, env(safe-area-inset-top)) 16px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    strong {
        font-size: 17px;
        line-height: 22px;
        font-weight: 800;
    }

    button {
        width: 34px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--primary-ink);
        background: var(--primary-soft);
        border-radius: 50%;
        font-size: 14px;
        font-weight: 800;
    }
}

.home-content {
    padding: 6px 14px 94px;
}

.home-hero {
    min-height: 340px;
    padding: 22px 14px 26px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #fff;
    text-align: center;
    background: linear-gradient(135deg, #ff7a1a 0%, #f4511e 52%, #ef2b2d 100%);
    border-radius: 26px;
    box-shadow: 0 16px 38px rgba(255, 107, 0, 0.3);
    position: relative;
    overflow: hidden;
}

.hero-burst {
    width: 180%;
    aspect-ratio: 1;
    position: absolute;
    left: 50%;
    top: 36%;
    transform: translate(-50%, -50%);
    background: repeating-conic-gradient(rgba(255, 220, 175, 0.28) 0deg 10deg, transparent 10deg 20deg);
    pointer-events: none;
}

.hero-cloud {
    width: min(100%, 312px);
    min-height: 150px;
    padding: 20px 14px 18px;
    color: var(--ink);
    background: #fff;
    border: 3px solid #1e1b2e;
    border-radius: 34px;
    position: relative;
    z-index: 1;

    &::before,
    &::after {
        content: "";
        position: absolute;
        bottom: -19px;
        background: #fff;
        border-bottom: 3px solid #1e1b2e;
    }

    &::before {
        width: 25px;
        height: 25px;
        left: calc(50% - 21px);
        border-left: 3px solid #1e1b2e;
        border-radius: 0 0 0 20px;
        transform: rotate(-35deg);
    }

    &::after {
        width: 28px;
        height: 22px;
        right: calc(50% - 23px);
        border-right: 3px solid #1e1b2e;
        border-radius: 0 0 20px;
        transform: rotate(35deg);
    }
}

.hero-cloud h1,
.hero-cloud h2 {
    position: relative;
    z-index: 1;
    font-size: 30px;
    line-height: 34px;
    font-weight: 900;
    letter-spacing: 0;
    -webkit-text-stroke: 1px #1e1b2e;
    text-shadow: 2px 2px 0 #1e1b2e;
}

.hero-cloud h1 {
    color: var(--primary);
}

.hero-cloud h2 {
    margin-top: 2px;
    color: #ff7043;
    font-size: 32px;
}

.hero-subtitle {
    width: fit-content;
    min-height: 29px;
    margin: 10px auto 0;
    padding: 5px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    color: #8f2f1f;
    background: linear-gradient(#fff0e8, #ffc4b2);
    border: 2px solid #1e1b2e;
    border-radius: 999px;
    font-size: 11px;
    line-height: 15px;
    font-weight: 800;

    i {
        width: 4px;
        height: 4px;
        flex: 0 0 4px;
        background: #1e1b2e;
        border-radius: 50%;
    }
}

.benefit-tags {
    max-width: 338px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 7px;
    position: relative;
    z-index: 1;

    span {
        min-height: 27px;
        padding: 5px 10px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        background: rgba(255, 255, 255, 0.14);
        border: 1px solid rgba(255, 255, 255, 0.28);
        border-radius: 999px;
        font-size: 11px;
        line-height: 15px;
        font-weight: 800;
    }
}

.selling-points {
    margin-top: 22px;

    > h2 {
        margin-bottom: 12px;
        font-size: 15px;
        line-height: 20px;
        font-weight: 800;
        letter-spacing: 0;
    }
}

.selling-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px 10px;
}

.selling-item {
    min-width: 0;
    display: flex;
    align-items: flex-start;
    gap: 8px;

    > div {
        min-width: 0;
        display: flex;
        flex-direction: column;
    }

    strong {
        font-size: 13.5px;
        line-height: 17px;
        font-weight: 800;
    }

    small {
        margin-top: 2px;
        color: var(--muted);
        font-size: 11px;
        line-height: 16px;
    }
}

.selling-icon {
    width: 36px;
    height: 36px;
    flex: 0 0 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--primary-soft);
    border-radius: 10px;
    font-size: 18px;
}

.entry-list {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.entry-item {
    width: 100%;
    min-height: 90px;
    padding: 18px;
    display: flex;
    align-items: center;
    gap: 15px;
    color: #fff;
    text-align: left;
    background: linear-gradient(135deg, #ff7043, var(--primary));
    border: 0;
    border-radius: 26px;
    box-shadow: 0 10px 24px rgba(244, 81, 30, 0.28);

    &:active {
        transform: scale(0.985);
    }
}

.entry-icon {
    width: 54px;
    height: 54px;
    flex: 0 0 54px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.2);
    font-size: 26px;
    line-height: 1;
}

.entry-copy {
    min-width: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 3px;

    strong {
        font-size: 18px;
        line-height: 24px;
        font-weight: 800;
    }

    small {
        color: rgba(255, 255, 255, 0.92);
        font-size: 12.5px;
        line-height: 19px;
    }
}

.entry-arrow {
    flex: 0 0 auto;
    color: rgba(255, 255, 255, 0.85);
    font-size: 22px;
    font-weight: 800;
}

.home-foot {
    margin-top: 18px;
    color: var(--faint);
    text-align: center;
    font-size: 11.5px;
    line-height: 16px;
    font-weight: 600;
}

.service-fab {
    width: 62px;
    height: 62px;
    position: fixed;
    right: max(14px, calc((100vw - 480px) / 2 + 14px));
    bottom: max(22px, env(safe-area-inset-bottom));
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: var(--primary-ink);
    background: #fff;
    border-radius: 50%;
    box-shadow: 0 8px 22px rgba(180, 55, 30, 0.2), 0 0 0 1px rgba(244, 81, 30, 0.16);
    z-index: 5;

    img {
        width: 40px;
        height: 40px;
        margin-top: 1px;
        border-radius: 50%;
    }

    > span:last-child {
        margin-top: -5px;
        font-size: 9px;
        line-height: 12px;
        font-weight: 800;
    }
}

.service-pulse {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    animation: service-pulse 2.4s ease-out infinite;
}

@keyframes service-pulse {
    0% { box-shadow: 0 0 0 0 rgba(244, 81, 30, 0.3); }
    70% { box-shadow: 0 0 0 12px rgba(244, 81, 30, 0); }
    100% { box-shadow: 0 0 0 0 rgba(244, 81, 30, 0); }
}

@media (max-width: 360px) {
    .home-content {
        padding-right: 12px;
        padding-left: 12px;
    }

    .home-hero {
        min-height: 326px;
        padding-right: 10px;
        padding-left: 10px;
    }

    .hero-cloud h1 {
        font-size: 27px;
        line-height: 31px;
    }

    .hero-cloud h2 {
        font-size: 29px;
        line-height: 32px;
    }

    .benefit-tags {
        gap: 6px;
    }

    .selling-grid {
        column-gap: 8px;
    }

    .selling-icon {
        width: 32px;
        height: 32px;
        flex-basis: 32px;
        font-size: 16px;
    }

    .selling-item small {
        font-size: 10.5px;
    }

    .entry-item {
        padding: 16px;
        gap: 12px;
    }
}
</style>
